import { render } from "./StudentHeader.vue?vue&type=template&id=8ca1974c"
import script from "./StudentHeader.vue?vue&type=script&lang=js"
export * from "./StudentHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__